// Theme configurations for the wedding photo app
export const THEMES = {

  // ── Light Themes ──────────────────────────────────────────────

  gardenRomance: {
    name: "Garden Romance",
    colors: {
      bg: "#faf8f5",
      panel: "#fffefb",
      "panel-2": "#f2ebe3",
      text: "#2e2620",
      muted: "#857870",
      stroke: "rgba(0,0,0,.08)",
      gold: "#c47a8a",
      gold2: "#a55e6e",
      gold3: "#e0aab8",
      danger: "#d45d52",
      "danger-2": "#bb463c"
    }
  },

  ivoryGold: {
    name: "Ivory Gold",
    colors: {
      bg: "#f7f3ec",
      panel: "#fffdfa",
      "panel-2": "#f2ece2",
      text: "#312b25",
      muted: "#7f7468",
      stroke: "rgba(0,0,0,.10)",
      gold: "#cfa15f",
      gold2: "#b98a47",
      gold3: "#e5c38f",
      danger: "#d45d52",
      "danger-2": "#bb463c"
    }
  },

  champagne: {
    name: "Champagne",
    colors: {
      bg: "#faf6ee",
      panel: "#fffdf8",
      "panel-2": "#f3ece0",
      text: "#3a2e1e",
      muted: "#8a7860",
      stroke: "rgba(0,0,0,.09)",
      gold: "#c8a46a",
      gold2: "#a88040",
      gold3: "#e0c898",
      danger: "#c0392b",
      "danger-2": "#a93226"
    }
  },

  blush: {
    name: "Blush & Pearl",
    colors: {
      bg: "#fdf8f9",
      panel: "#fff5f7",
      "panel-2": "#f9eef0",
      text: "#3d2530",
      muted: "#9a7080",
      stroke: "rgba(0,0,0,.08)",
      gold: "#e8829a",
      gold2: "#c96080",
      gold3: "#f5b8c8",
      danger: "#c0392b",
      "danger-2": "#a93226"
    }
  },

  roseGold: {
    name: "Rose Gold",
    colors: {
      bg: "#fdf5f4",
      panel: "#fff9f8",
      "panel-2": "#f5ebe9",
      text: "#3d2020",
      muted: "#8a6060",
      stroke: "rgba(0,0,0,.08)",
      gold: "#d4826a",
      gold2: "#b86050",
      gold3: "#ebb8a8",
      danger: "#c0392b",
      "danger-2": "#a93226"
    }
  },

  sage: {
    name: "Sage & Cream",
    colors: {
      bg: "#f4f7f3",
      panel: "#fafcf9",
      "panel-2": "#e8efe5",
      text: "#2a3328",
      muted: "#6b7d68",
      stroke: "rgba(0,0,0,.09)",
      gold: "#6b9e6b",
      gold2: "#4d7d4d",
      gold3: "#9ec49e",
      danger: "#c0392b",
      "danger-2": "#a93226"
    }
  },

  oliveSage: {
    name: "Olive Sage",
    colors: {
      bg: "#f4f3ee",
      panel: "#fffdf9",
      "panel-2": "#ece8df",
      text: "#2d3328",
      muted: "#6b715d",
      stroke: "rgba(0,0,0,.08)",
      gold: "#7e8c73",
      gold2: "#68745f",
      gold3: "#a9b39a",
      danger: "#b56953",
      "danger-2": "#955747"
    }
  },

  lavender: {
    name: "Lavender Dream",
    colors: {
      bg: "#f5f3fa",
      panel: "#faf9fe",
      "panel-2": "#ece8f5",
      text: "#2d2540",
      muted: "#7d7090",
      stroke: "rgba(0,0,0,.08)",
      gold: "#9b7fc7",
      gold2: "#7d5fb0",
      gold3: "#c0a8e0",
      danger: "#c0392b",
      "danger-2": "#a93226"
    }
  },

  ocean: {
    name: "Ocean Blue",
    colors: {
      bg: "#f0f6fa",
      panel: "#f8fbff",
      "panel-2": "#deedf7",
      text: "#1a2d40",
      muted: "#5a7d9a",
      stroke: "rgba(0,0,0,.09)",
      gold: "#3a90c8",
      gold2: "#2070a8",
      gold3: "#80c0e8",
      danger: "#c0392b",
      "danger-2": "#a93226"
    }
  },

  // ── Frosted Glass Themes ──────────────────────────────────────

  noirRomance: {
    name: "Noir Romance",
    colors: {
      bg: "rgba(0,0,0,0)",
      panel: "#0e0c0a",
      "panel-2": "#181410",
      text: "#f5f0e8",
      muted: "#c0aa8c",
      stroke: "rgba(255,255,255,.11)",
      gold: "#e4d0a0",
      gold2: "#c4a868",
      gold3: "#f2e4c0",
      danger: "#e05252",
      "danger-2": "#c43c3c",
      "panel-glass": "rgba(10,8,6,0.74)",
      "backdrop-blur": "blur(20px) saturate(1.3)"
    }
  },

  frostedGarden: {
    name: "Frosted Garden",
    colors: {
      bg: "rgba(0,0,0,0)",
      panel: "#1a1410",
      "panel-2": "#231c14",
      text: "#f4efe6",
      muted: "#c8b898",
      stroke: "rgba(255,255,255,.14)",
      gold: "#d9a84a",
      gold2: "#b88830",
      gold3: "#f0cc80",
      danger: "#e05252",
      "danger-2": "#c43c3c",
      "panel-glass": "rgba(18,14,10,0.62)",
      "backdrop-blur": "blur(18px) saturate(1.5)"
    }
  },

  frostedSilver: {
    name: "Frosted Silver",
    colors: {
      bg: "rgba(0,0,0,0)",
      panel: "#14181e",
      "panel-2": "#1c2028",
      text: "#edf0f5",
      muted: "#b8c8de",
      stroke: "rgba(255,255,255,.14)",
      gold: "#dce8f8",
      gold2: "#b0c4e0",
      gold3: "#eef4ff",
      danger: "#e05252",
      "danger-2": "#c43c3c",
      "panel-glass": "rgba(14,16,20,0.62)",
      "backdrop-blur": "blur(18px) saturate(1.5)"
    }
  },

  frostedLight: {
    name: "Frosted Pearl",
    colors: {
      bg: "rgba(0,0,0,0)",
      panel: "#faf6f0",
      "panel-2": "#f0e8dc",
      text: "#1e1810",
      muted: "#6e5a48",
      stroke: "rgba(0,0,0,.12)",
      gold: "#b87040",
      gold2: "#965830",
      gold3: "#d9a878",
      danger: "#d45d52",
      "danger-2": "#bb463c",
      "panel-glass": "rgba(255,252,248,0.58)",
      "backdrop-blur": "blur(18px) saturate(1.4)"
    }
  },

  // ── Dark Themes ───────────────────────────────────────────────

  vintageWedding: {
    name: "Custom Theme 1",
    colors: {
      bg: "#1f211c",
      panel: "rgba(243,234,207,0.34)",
      "panel-2": "rgba(123,120,94,0.24)",
      text: "#f8f1df",
      muted: "rgba(255,249,233,0.82)",
      stroke: "rgba(255,249,233,0.72)",
      gold: "#d7c38d",
      gold2: "#bca66b",
      gold3: "#f1e7c8",
      danger: "#b56953",
      "danger-2": "#955747",
      "upload-panel": "#7e8c73",
      "browse-button": "#c4c7a9",
      "upload-button": "#b3b89d",
      "browse-button-end": "#899174",
      "upload-button-end": "#7a8169",
      "button-gradient-angle": "180deg",
      "button-text": "#f8f1df",
      "panel-glass": "rgba(220,210,180,0.14)",
      "backdrop-blur": "blur(13px) saturate(1.05)"
    }
  },

  customTheme2: {
    name: "Custom Theme 2",
    colors: {
      bg: "#141210",
      panel: "rgba(35,23,18,0.40)",
      "panel-2": "rgba(0,0,0,0.17)",
      text: "#F8F3EB",
      muted: "rgba(248,243,235,0.82)",
      stroke: "#D6BE9D",
      gold: "#D6BE9D",
      gold2: "#D2AE85",
      gold3: "#F1DDC0",
      danger: "#b56953",
      "danger-2": "#955747",
      "upload-panel": "rgba(35,23,18,0.40)",
      "browse-button": "#F1DDC0",
      "upload-button": "#F1DDC0",
      "browse-button-end": "#D2AE85",
      "upload-button-end": "#D2AE85",
      "button-gradient-angle": "135deg",
      "button-text": "#251911"
    }
  },

  classic: {
    name: "Classic Gold",
    colors: {
      bg: "#141516",
      panel: "#222326",
      "panel-2": "#2a2c2f",
      text: "#EDEDED",
      muted: "#A8ACB3",
      stroke: "rgba(255,255,255,.08)",
      gold: "#E2B653",
      gold2: "#C99F41",
      gold3: "#f6d58a",
      danger: "#E74C3C",
      "danger-2": "#C0392B"
    }
  },

  midnight: {
    name: "Midnight Blue",
    colors: {
      bg: "#0d1b2a",
      panel: "#162437",
      "panel-2": "#1e3048",
      text: "#e0eaf4",
      muted: "#7a9ab8",
      stroke: "rgba(255,255,255,.08)",
      gold: "#6ab4d8",
      gold2: "#4898c0",
      gold3: "#9ad0ec",
      danger: "#e05252",
      "danger-2": "#c43c3c"
    }
  },

  burgundy: {
    name: "Burgundy",
    colors: {
      bg: "#1a0a10",
      panel: "#2a1018",
      "panel-2": "#361520",
      text: "#f0e4e8",
      muted: "#b08090",
      stroke: "rgba(255,255,255,.07)",
      gold: "#c87a8a",
      gold2: "#a85e6e",
      gold3: "#e0a8b8",
      danger: "#e05252",
      "danger-2": "#c43c3c"
    }
  },

  emerald: {
    name: "Forest Emerald",
    colors: {
      bg: "#0a1a12",
      panel: "#102a1c",
      "panel-2": "#183824",
      text: "#d8f0e4",
      muted: "#6aaa84",
      stroke: "rgba(255,255,255,.07)",
      gold: "#44c48a",
      gold2: "#30a870",
      gold3: "#78d8a8",
      danger: "#e05252",
      "danger-2": "#c43c3c"
    }
  },

  silverNight: {
    name: "Silver Night",
    colors: {
      bg: "#18181e",
      panel: "#222230",
      "panel-2": "#2a2a3a",
      text: "#e8e8f2",
      muted: "#9090b0",
      stroke: "rgba(255,255,255,.09)",
      gold: "#a8b4d4",
      gold2: "#8090b8",
      gold3: "#c8d4f0",
      danger: "#e05252",
      "danger-2": "#c43c3c"
    }
  },

  velvet: {
    name: "Velvet Rose",
    colors: {
      bg: "#1a1018",
      panel: "#281828",
      "panel-2": "#341e32",
      text: "#f0e0ee",
      muted: "#b880b0",
      stroke: "rgba(255,255,255,.07)",
      gold: "#d880c0",
      gold2: "#b860a0",
      gold3: "#f0a8d8",
      danger: "#e05252",
      "danger-2": "#c43c3c"
    }
  },

  // ── Default (fallback) ─────────────────────────────────────────

  default: {
    name: "Default",
    colors: {
      bg: "#ffffff",
      panel: "#f8f9fa",
      "panel-2": "#e9ecef",
      text: "#212529",
      muted: "#6c757d",
      stroke: "#dee2e6",
      gold: "#ffc107",
      gold2: "#fd7e14",
      gold3: "#f6d58a",
      danger: "#dc3545",
      "danger-2": "#c82333"
    }
  }
};
